import axios from 'axios';
import { updateField, getField } from 'vuex-map-fields';

const convertProfile = async (data) => {
  const payload = {
    actions: {},
    answers: {},
    manual: {},
    submits: {},
    treatments: {},
    reports: {},
    trash: {},
    dashboard: {},
    clients: {},
    action_groups: {},
    config: {},
    files: {},
    panels: {},
  };
  // eslint-disable-next-line
  for (const key in data) {
    if (key === 'Ações') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.actions.menu_list = obj.value;
        }

        if (obj.name === 'Detalhes') {
          payload.actions.details = obj.value;
        }

        if (obj.name === 'Editar Ação') {
          payload.actions.edit = obj.value;
        }

        if (obj.name === 'Enviar (disparo)') {
          payload.actions.submit = obj.value;
        }

        if (obj.name === 'Excluir Ação') {
          payload.actions.delete = obj.value;
        }

        if (obj.name === 'Criar Ação') {
          payload.actions.create = obj.value;
        }
      });
    }
    if (key === 'Respostas') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.answers.menu = obj.value;
        }

        if (obj.name === 'Editar Comentário') {
          payload.answers.edit_feedback = obj.value;
        }

        if (obj.name === 'Excluir Resposta') {
          payload.answers.delete = obj.value;
        }

        if (obj.name === 'Modo anônimo') {
          payload.answers.anonymous_profile = obj.value;
        }

        if (obj.name === 'Modo categorização') {
          payload.answers.categorization = obj.value;
        }
      });
    }
    if (key === 'Manual') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.manual.menu = obj.value;
        }

        if (obj.name === 'Registrar Resposta') {
          payload.manual.submit = obj.value;
        }

        if (obj.name === 'Modo anônimo') {
          payload.manual.anonymous_profile = obj.value;
        }
      });
    }
    if (key === 'Disparos') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.submits.menu = obj.value;
        }

        if (obj.name === 'Visualizar Reenvio') {
          payload.submits.resendMenu = obj.value;
        }

        if (obj.name === 'Reenviar Whatsapp') {
          payload.submits.resendWpp = obj.value;
        }

        if (obj.name === 'Visualizar Whatsapp') {
          payload.submits.resendWppMenu = obj.value;
        }

        if (obj.name === 'Executar reenvio') {
          payload.submits.resend = obj.value;
        }

        if (obj.name === 'Visualizar Lembretes') {
          payload.submits.reminderMenu = obj.value;
        }

        if (obj.name === 'Cancelar Lembretes') {
          payload.submits.cancelReminder = obj.value;
        }

        if (obj.name === 'Visualizar Agendamentos') {
          payload.submits.schedulingMenu = obj.value;
        }

        if (obj.name === 'Cancelar Agendamentos') {
          payload.submits.cancelScheduling = obj.value;
        }

        if (obj.name === 'Modo anônimo') {
          payload.submits.anonymous_profile = obj.value;
        }
      });
    }
    if (key === 'Tratativas') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.treatments.menu = obj.value;
        }

        if (obj.name === 'Detalhes') {
          payload.treatments.details = obj.value;
        }

        if (obj.name === 'Categorizar Resposta') {
          payload.treatments.category = obj.value;
        }

        if (obj.name === 'Alterar Status') {
          payload.treatments.status = obj.value;
        }

        if (obj.name === 'Alterar Status Encerrado') {
          payload.treatments.statusClosed = obj.value;
        }

        if (obj.name === 'Tratativa em Massa') {
          payload.treatments.bulk = obj.value;
        }

        if (obj.name === 'Responder por email') {
          payload.treatments.emailresponse = obj.value;
        }

        if (obj.name === 'Categorizar tratativa') {
          payload.treatments.treatmentCategory = obj.value;
        }

        if (obj.name === 'Habilitar comentário') {
          payload.treatments.enableComment = obj.value;
        }

        if (obj.name === 'Habilitar responsável') {
          payload.treatments.enableResponsible = obj.value;
        }

        if (obj.name === 'Habilitar anexo') {
          payload.treatments.enableAttachment = obj.value;
        }

        if (obj.name === 'Habilitar close the loop') {
          payload.treatments.closetheloop = obj.value;
        }

        if (obj.name === 'Revisão de tratativas') {
          payload.treatments.revision = obj.value;
        }
      });
    }
    if (key === 'Relatórios') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.reports.menu = obj.value;
        }
        if (obj.name === 'Power BI') {
          payload.reports.powerbi = obj.value;
        }
        if (obj.name === 'Análise IA') {
          payload.reports.AIAnalysis = obj.value;
        }
      });
    }
    if (key === 'Lixeira') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.trash.menu = obj.value;
        }

        if (obj.name === 'Restaurar Resposta') {
          payload.trash.undo_answer = obj.value;
        }

        if (obj.name === 'Restaurar Ação') {
          payload.trash.undo_action = obj.value;
        }

        if (obj.name === 'Modo anônimo') {
          payload.trash.anonymous_profile = obj.value;
        }
      });
    }
    if (key === 'Dashboard') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.dashboard.menu = obj.value;
        }
      });
    }
    if (key === 'Clientes') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.clients.menu = obj.value;
        }

        if (obj.name === 'Modo anônimo') {
          payload.clients.anonymous_profile = obj.value;
        }

        if (obj.name === 'Editar dados') {
          payload.clients.edit_data = obj.value;
        }
      });
    }
    if (key === 'Grupo de Ações') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.action_groups.menu = obj.value;
        }
        if (obj.name === 'Associação de Ações') {
          payload.action_groups.associate_action = obj.value;
        }
      });
    }
    if (key === 'Configurações') {
      data[key].map((obj) => {
        if (obj.name === 'Visualizar Menu') {
          payload.config.menu = obj.value;
        }
      });
    }
    if (key === 'Arquivos') {
      data[key].map((obj) => {
        if (obj.name === 'Downloads') {
          payload.files.download = obj.value;
        }
        if (obj.name === 'Uploads') {
          payload.files.upload = obj.value;
        }
      });
    }
    if (key === 'Painéis') {
      data[key].map((obj) => {
        if (payload.panels) {
          if (obj.name === 'Visualizar Menu') {
            payload.panels.view_menu = obj.value;
          }
          if (obj.name === 'Compartilhar Painéis') {
            payload.panels.share_panel = obj.value;
          }
          if (obj.name === 'Criar Painéis') {
            payload.panels.create_panel = obj.value;
          }
          if (obj.name === 'Editar Painéis') {
            payload.panels.edit_panel = obj.value;
          }
          if (obj.name === 'Excluir Painéis') {
            payload.panels.delete_panel = obj.value;
          }
        }
      });
    }
  }

  return payload;
};

export default {
  namespaced: true,
  state: {
    allPermissions: [],
    profiles: [],
    nameProfile: null,
    permissions: {
      Ações: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Detalhes',
          value: false,
        },
        {
          name: 'Editar Ação',
          value: false,
        },
        {
          name: 'Enviar (disparo)',
          value: false,
        },
        {
          name: 'Excluir Ação',
          value: false,
        },
        {
          name: 'Criar Ação',
          value: false,
        },
      ],
      Respostas: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Editar Comentário',
          value: false,
        },
        {
          name: 'Excluir Resposta',
          value: false,
        },
        {
          name: 'Modo categorização',
          value: false,
        },
      ],
      Manual: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Registrar Resposta',
          value: false,
        },
      ],
      Disparos: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Visualizar Reenvio',
          value: false,
        },
        {
          name: 'Executar reenvio',
          value: false,
        },
        {
          name: 'Visualizar Lembretes',
          value: false,
        },
        {
          name: 'Cancelar Lembretes',
          value: false,
        },
        {
          name: 'Visualizar Agendimentos',
          value: false,
        },
        {
          name: 'Cancelar Agendimentos',
          value: false,
        },
      ],
      Tratativas: [
        {
          name: 'Cancelar Lembretes',
          value: false,
        },
        {
          name: 'Detalhes',
          value: false,
        },
        {
          name: 'Categorizar Resposta',
          value: false,
        },
        {
          name: 'Alterar Status',
          value: false,
        },
        {
          name: 'Alterar Status Encerrado',
          value: false,
        },
        {
          name: 'Tratativa em Massa',
          value: false,
        },
        {
          name: 'Responder por email',
          value: false,
        },
        {
          name: 'Categorizar tratativa',
          value: false,
        },
        {
          name: 'Habilitar comentário',
          value: false,
        },
      ],
      Relatórios: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Power BI',
          value: false,
        },
        // {
        //   name: 'Análise IA',
        //   value: false,
        // },
      ],
      Lixeira: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Restaurar Resposta',
          value: false,
        },
        {
          name: 'Restaurar Ação',
          value: false,
        },
      ],
      Dashboard: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
      ],
      Clientes: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Editar dados',
          value: false,
        },
      ],
      'Grupo de Ações': [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Associação de Ações',
          value: false,
        },
      ],
      Configurações: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
      ],
      Arquivos: [
        {
          name: 'Downloads',
          value: false,
        },
        {
          name: 'Uploads',
          value: false,
        },
      ],
      Painéis: [
        {
          name: 'Visualizar Menu',
          value: false,
        },
        {
          name: 'Compartilhar Painéis',
          value: false,
        },
        {
          name: 'Criar Painéis',
          value: false,
        },
        {
          name: 'Editar Painéis',
          value: false,
        },
        {
          name: 'Excluir Painéis',
          value: false,
        },
      ],
    },
    profileType: null,
    profileId: null,
  },
  getters: {
    getField,
  },
  actions: {
    async createProfile({ commit, state }, data) {
      const permissions = await convertProfile(state.permissions);

      await axios.post(
        `${process.env.API_ROOT}/profile/${data.companyId}`,
        {
          permissions,
          name: state.nameProfile,
        },
        {
          headers: {
            'x-access-token': data.token,
          },
        },
      );

      commit('SET_PERMISSIONS_DEFAULT', true);
    },

    async getProfiles({ commit }, obj) {
      const profiles = [];

      const { data } = await axios.get(
        `${process.env.API_ROOT}/profiles/${obj.companyId}`,
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );

      data.forEach((el) => {
        profiles.push({ value: el._id, text: el.name });
      });

      commit('SET_PROFILES', profiles);
      commit('SET_ALL_PERMISSIONS', data);
    },

    async editProfile({ commit, state }, data) {
      const permissions = await convertProfile(state.permissions);

      await axios.put(
        `${process.env.API_ROOT}/profile/${data.profileId}`,
        {
          permissions,
          name: data.nameProfile,
        },
        {
          headers: {
            'x-access-token': data.token,
          },
        },
      );
    },

    async deletePermissions({ commit }, obj) {
      await axios.delete(`${process.env.API_ROOT}/profile/${obj.profileId}`, {
        headers: {
          'x-access-token': obj.token,
        },
      });
    },

    async getProfile({ commit }, obj) {
      const response = await axios.get(
        `${process.env.API_ROOT}/profile/${obj.profileId}`,
        {
          headers: {
            'x-access-token': obj.token,
          },
          params: {
            email: obj.email,
            changeProfile: obj.changeProfile,
          },
        },
      );
      // commit('GET_PROFILE', response.data);
      return response.data;
    },

    async profileAttributes({ commit, state }, obj) {
      const permissions = await convertProfile(state.permissions);

      if (
        obj.profileId === '5e74d116495c4f4c08aadf34' ||
        obj.profileId === '5e74d204495c4f4c08aadf36'
      ) {
        permissions.reports.AIAnalysis = true;
      }

      const response = await axios.post(
        `${process.env.API_ROOT}/user/profile/${obj.profileId}/${obj.userId}`,
        {
          permissions,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
      commit('GET_PROFILE', response.data);
    },

    async setStateProfile({ commit }, obj) {
      const nameProfile = obj.name;
      let permissions = [];
      if (obj.lang === 'br') {
        permissions = {
          Ações: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.actions.menu_list,
            },
            {
              name: 'Detalhes',
              value: obj.permissions.actions.details,
            },
            {
              name: 'Editar Ação',
              value: obj.permissions.actions.edit,
            },
            {
              name: 'Enviar (disparo)',
              value: obj.permissions.actions.submit,
            },
            {
              name: 'Excluir Ação',
              value: obj.permissions.actions.delete,
            },
            {
              name: 'Criar Ação',
              value: obj.permissions.actions.create,
            },
          ],
          Respostas: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.answers.menu,
            },
            {
              name: 'Editar Comentário',
              value: obj.permissions.answers.edit_feedback,
            },
            {
              name: 'Excluir Resposta',
              value: obj.permissions.answers.delete,
            },
            {
              name: 'Modo anônimo',
              value: obj.permissions.answers.anonymous_profile,
            },
            {
              name: 'Modo categorização',
              value: obj.permissions.answers.categorization,
            },
          ],
          Manual: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.manual.menu,
            },
            {
              name: 'Registrar Resposta',
              value: obj.permissions.manual.submit,
            },
            {
              name: 'Modo anônimo',
              value: obj.permissions.manual.anonymous_profile,
            },
          ],
          Disparos: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.submits.menu,
            },
            {
              name: 'Visualizar Reenvio',
              value: obj.permissions.submits.resendMenu,
            },
            {
              name: 'Reenviar Whatsapp',
              value: obj.permissions.submits.resendWpp,
            },
            {
              name: 'Visualizar Whatsapp',
              value: obj.permissions.submits.resendWppMenu,
            },
            {
              name: 'Executar reenvio',
              value: obj.permissions.submits.resend,
            },
            {
              name: 'Visualizar Lembretes',
              value: obj.permissions.submits.reminderMenu,
            },
            {
              name: 'Cancelar Lembretes',
              value: obj.permissions.submits.cancelReminder,
            },
            {
              name: 'Visualizar Agendamentos',
              value: obj.permissions.submits.schedulingMenu,
            },
            {
              name: 'Cancelar Agendamentos',
              value: obj.permissions.submits.cancelScheduling,
            },
            {
              name: 'Modo anônimo',
              value: obj.permissions.submits.anonymous_profile,
            },
          ],
          Tratativas: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.treatments.menu,
            },
            {
              name: 'Detalhes',
              value: obj.permissions.treatments.details,
            },
            {
              name: 'Categorizar Resposta',
              value: obj.permissions.treatments.category,
            },
            {
              name: 'Alterar Status',
              value: obj.permissions.treatments.status,
            },
            {
              name: 'Alterar Status Encerrado',
              value: obj.permissions.treatments.statusClosed,
            },
            {
              name: 'Tratativa em Massa',
              value: obj.permissions.treatments.bulk,
            },
            {
              name: 'Responder por email',
              value: obj.permissions.treatments.emailresponse,
            },
            {
              name: 'Categorizar tratativa',
              value: obj.permissions.treatments.treatmentCategory,
            },
            {
              name: 'Habilitar comentário',
              value: obj.permissions.treatments.enableComment,
            },
            {
              name: 'Habilitar responsável',
              value: obj.permissions.treatments.enableResponsible,
            },
            {
              name: 'Habilitar anexo',
              value: obj.permissions.treatments.enableAttachment,
            },
            {
              name: 'Habilitar close the loop',
              value: obj.permissions.treatments.closetheloop,
            },
            {
              name: 'Revisão de tratativas',
              value: obj.permissions.treatments.revision,
            },
          ],
          Relatórios: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.reports.menu,
            },
            {
              name: 'Power BI',
              value: obj.permissions.reports.powerbi,
            },
            // {
            //   name: 'Análise IA',
            //   value: obj.permissions.reports.AIAnalysis,
            // },
          ],
          Lixeira: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.trash.menu,
            },
            {
              name: 'Restaurar Resposta',
              value: obj.permissions.trash.undo_answer,
            },
            {
              name: 'Restaurar Ação',
              value: obj.permissions.trash.undo_action,
            },
            {
              name: 'Modo anônimo',
              value: obj.permissions.trash.anonymous_profile,
            },
          ],
          Dashboard: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.dashboard.menu,
            },
          ],
          Clientes: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.clients.menu,
            },
            {
              name: 'Modo anônimo',
              value: obj.permissions.clients.anonymous_profile,
            },
            {
              name: 'Editar dados',
              value: obj.permissions.clients.edit_data,
            },
          ],
          'Grupo de Ações': [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.action_groups.menu,
            },
            {
              name: 'Associação de Ações',
              value: obj.permissions.action_groups.associate_action,
            },
          ],
          Configurações: [
            {
              name: 'Visualizar Menu',
              value: obj.permissions.config.menu,
            },
          ],
          Arquivos: [
            {
              name: 'Downloads',
              value: obj.permissions.files.download,
            },
            {
              name: 'Uploads',
              value: obj.permissions.files.upload,
            },
          ],
          Painéis: [
            {
              name: 'Visualizar Menu',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.view_menu
                  : false,
            },
            {
              name: 'Compartilhar Painéis',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.share_panel
                  : false,
            },
            {
              name: 'Criar Painéis',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.create_panel
                  : false,
            },
            {
              name: 'Editar Painéis',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.edit_panel
                  : false,
            },
            {
              name: 'Excluir Painéis',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.delete_panel
                  : false,
            },
          ],
        };
      }

      if (obj.lang === 'us') {
        permissions = {
          Actions: [
            {
              name: 'View Menu',
              value: obj.permissions.actions.menu_list,
            },
            {
              name: 'Details',
              value: obj.permissions.actions.details,
            },
            {
              name: 'Edit Action',
              value: obj.permissions.actions.edit,
            },
            {
              name: 'Send (shoot)',
              value: obj.permissions.actions.submit,
            },
            {
              name: 'Delete action',
              value: obj.permissions.actions.delete,
            },
            {
              name: 'Create action',
              value: obj.permissions.actions.create,
            },
          ],
          Answers: [
            {
              name: 'View menu',
              value: obj.permissions.answers.menu,
            },
            {
              name: 'Edit comment',
              value: obj.permissions.answers.edit_feedback,
            },
            {
              name: 'Delete answer',
              value: obj.permissions.answers.delete,
            },
            {
              name: 'Anonymous mode',
              value: obj.permissions.answers.anonymous_profile,
            },
            {
              name: 'Categorization mode',
              value: obj.permissions.answers.categorization,
            },
          ],
          Manual: [
            {
              name: 'View menu',
              value: obj.permissions.manual.menu,
            },
            {
              name: 'Register Answer',
              value: obj.permissions.manual.submit,
            },
            {
              name: 'Anonymous mode',
              value: obj.permissions.manual.anonymous_profile,
            },
          ],
          Dispatch: [
            {
              name: 'View Menu',
              value: obj.permissions.submits.menu,
            },
            {
              name: 'View resend',
              value: obj.permissions.submits.resendMenu,
            },
            {
              name: 'Resend Whatsapp',
              value: obj.permissions.submits.resendWpp,
            },
            {
              name: 'View Whatsapp',
              value: obj.permissions.submits.resendWppMenu,
            },
            {
              name: 'Execute resend',
              value: obj.permissions.submits.resend,
            },
            {
              name: 'View reminder',
              value: obj.permissions.submits.reminderMenu,
            },
            {
              name: 'Cancel reminders',
              value: obj.permissions.submits.cancelReminder,
            },
            {
              name: 'View Schedules',
              value: obj.permissions.submits.schedulingMenu,
            },
            {
              name: 'Cancel Schedules',
              value: obj.permissions.submits.cancelScheduling,
            },
            {
              name: 'Incognito mode',
              value: obj.permissions.submits.anonymous_profile,
            },
          ],
          treatments: [
            {
              name: 'View menu',
              value: obj.permissions.treatments.menu,
            },
            {
              name: 'Details',
              value: obj.permissions.treatments.details,
            },
            {
              name: 'Categorize Answer',
              value: obj.permissions.treatments.category,
            },
            {
              name: 'Change Status',
              value: obj.permissions.treatments.status,
            },
            {
              name: 'Change Closed Status',
              value: obj.permissions.treatments.statusClosed,
            },
            {
              name: 'Mass Treatments',
              value: obj.permissions.treatments.bulk,
            },
            {
              name: 'Reply by email',
              value: obj.permissions.treatments.emailresponse,
            },
            {
              name: 'Categorize Negotiations',
              value: obj.permissions.treatments.treatmentCategory,
            },
            {
              name: 'Enable comment',
              value: obj.permissions.treatments.enableComment,
            },
            {
              name: 'Enable responsible',
              value: obj.permissions.treatments.enableResponsible,
            },
            {
              name: 'Enable attachment',
              value: obj.permissions.treatments.enableAttachment,
            },
            {
              name: 'Enable close the loop',
              value: obj.permissions.treatments.closetheloop,
            },
          ],
          reports: [
            {
              name: 'View menu',
              value: obj.permissions.reports.menu,
            },
            {
              name: 'Power BI',
              value: obj.permissions.reports.powerbi,
            },
            {
              name: 'AI Analysis',
              value: obj.permissions.reports.AIAnalysis,
            },
          ],
          Trash: [
            {
              name: 'View menu',
              value: obj.permissions.trash.menu,
            },
            {
              name: 'Restore answer',
              value: obj.permissions.trash.undo_answer,
            },
            {
              name: 'Restore actions',
              value: obj.permissions.trash.undo_action,
            },
            {
              name: 'Incognito mode',
              value: obj.permissions.trash.anonymous_profile,
            },
          ],
          Dashboard: [
            {
              name: 'View Menu',
              value: obj.permissions.dashboard.menu,
            },
          ],
          Customers: [
            {
              name: 'View Menu',
              value: obj.permissions.clients.menu,
            },
            {
              name: 'Incognito mode',
              value: obj.permissions.clients.anonymous_profile,
            },
            {
              name: 'Edit data',
              value: obj.permissions.clients.edit_data,
            },
          ],
          'Share Group': [
            {
              name: 'View Menu',
              value: obj.permissions.action_groups.menu,
            },
            {
              name: 'Action Association',
              value: obj.permissions.action_groups.associate_action,
            },
          ],
          Settings: [
            {
              name: 'View menu',
              value: obj.permissions.config.menu,
            },
          ],
          Files: [
            {
              name: 'Downloads',
              value: obj.permissions.files.download,
            },
            {
              name: 'Uploads',
              value: obj.permissions.files.upload,
            },
          ],
          Panels: [
            {
              name: 'View menu',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.view_menu
                  : false,
            },
            {
              name: 'Share panels',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.share_panel
                  : false,
            },
            {
              name: 'Create panels',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.create_panel
                  : false,
            },
            {
              name: 'Edit panels',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.edit_panel
                  : false,
            },
            {
              name: 'Remove panels',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.delete_panel
                  : false,
            },
          ],
        };
      }

      if (obj.lang === 'es') {
        permissions = {
          Acciones: [
            {
              name: 'Ver Menu',
              value: obj.permissions.actions.menu_list,
            },
            {
              name: 'Detalles',
              value: obj.permissions.actions.details,
            },
            {
              name: 'Editar Acción',
              value: obj.permissions.actions.edit,
            },
            {
              name: ' Enviar (disparo)',
              value: obj.permissions.actions.submit,
            },
            {
              name: 'Borrar Acciones',
              value: obj.permissions.actions.delete,
            },
            {
              name: 'Crear Acciones',
              value: obj.permissions.actions.create,
            },
          ],
          Respuestas: [
            {
              name: 'Ver Menu',
              value: obj.permissions.answers.menu,
            },
            {
              name: 'Editar comentario',
              value: obj.permissions.answers.edit_feedback,
            },
            {
              name: 'Eliminar Respuesta ',
              value: obj.permissions.answers.delete,
            },
            {
              name: 'Modo incognito',
              value: obj.permissions.answers.anonymous_profile,
            },
            {
              name: 'Modo de categorización',
              value: obj.permissions.answers.categorization,
            },
          ],
          Manual: [
            {
              name: 'Ver Menu',
              value: obj.permissions.manual.menu,
            },
            {
              name: 'Registrar Respuesta',
              value: obj.permissions.manual.submit,
            },
            {
              name: 'Modo incognito',
              value: obj.permissions.manual.anonymous_profile,
            },
          ],
          Disparos: [
            {
              name: 'Ver Menu',
              value: obj.permissions.submits.menu,
            },
            {
              name: 'Ver Reenviar',
              value: obj.permissions.submits.resendMenu,
            },
            {
              name: 'Reenviar Whatsapp',
              value: obj.permissions.submits.resendWpp,
            },
            {
              name: 'Ver Whatsapp',
              value: obj.permissions.submits.resendWppMenu,
            },
            {
              name: 'Ejecutar Reenviar',
              value: obj.permissions.submits.resend,
            },
            {
              name: 'Ver Lembretes',
              value: obj.permissions.submits.reminderMenu,
            },
            {
              name: 'Cancelar Recordatorios',
              value: obj.permissions.submits.cancelReminder,
            },
            {
              name: ' Ver Horarios',
              value: obj.permissions.submits.schedulingMenu,
            },
            {
              name: 'Cancelar Recordatorios',
              value: obj.permissions.submits.cancelScheduling,
            },
            {
              name: 'Modo incognito',
              value: obj.permissions.submits.anonymous_profile,
            },
          ],
          Tratativas: [
            {
              name: 'Ver Menu',
              value: obj.permissions.treatments.menu,
            },
            {
              name: 'Detalles',
              value: obj.permissions.treatments.details,
            },
            {
              name: 'Categorizar Respuesta',
              value: obj.permissions.treatments.category,
            },
            {
              name: 'Cambiar Status',
              value: obj.permissions.treatments.status,
            },
            {
              name: 'Cambiar Status Cerrado',
              value: obj.permissions.treatments.statusClosed,
            },
            {
              name: 'Tratativas en Massa',
              value: obj.permissions.treatments.bulk,
            },
            {
              name: 'Responder por email',
              value: obj.permissions.treatments.emailresponse,
            },
            {
              name: ' Categorizar negociaciones',
              value: obj.permissions.treatments.treatmentCategory,
            },
            {
              name: 'Habilitar comentario',
              value: obj.permissions.treatments.enableComment,
            },
            {
              name: 'Habilitar responsable',
              value: obj.permissions.treatments.enableResponsible,
            },
            {
              name: 'Habilitar documento adjunto em anexo',
              value: obj.permissions.treatments.enableAttachment,
            },
            {
              name: 'Habilitar cerrar el ciclo',
              value: obj.permissions.treatments.closetheloop,
            },
          ],
          Reportes: [
            {
              name: 'Ver Menu',
              value: obj.permissions.reports.menu,
            },
            {
              name: 'Power BI',
              value: obj.permissions.reports.powerbi,
            },
            {
              name: 'Análisis IA',
              value: obj.permissions.reports.AIAnalysis,
            },
          ],
          Basurero: [
            {
              name: 'Ver Menu',
              value: obj.permissions.trash.menu,
            },
            {
              name: 'Restaurar Respuesta',
              value: obj.permissions.trash.undo_answer,
            },
            {
              name: 'Restaurar Accíon',
              value: obj.permissions.trash.undo_action,
            },
            {
              name: 'Modo incognito',
              value: obj.permissions.trash.anonymous_profile,
            },
          ],
          Dashboard: [
            {
              name: 'Ver Menu',
              value: obj.permissions.dashboard.menu,
            },
          ],
          Clientes: [
            {
              name: 'Ver Menu',
              value: obj.permissions.clients.menu,
            },
            {
              name: 'Modo incógnito',
              value: obj.permissions.clients.anonymous_profile,
            },
            {
              name: 'Editar datos',
              value: obj.permissions.clients.edit_data,
            },
          ],
          'Grupo de Acciones': [
            {
              name: 'Ver Menu',
              value: obj.permissions.action_groups.menu,
            },
            {
              name: 'Asociación de Aciones',
              value: obj.permissions.action_groups.associate_action,
            },
          ],
          Configuraciones: [
            {
              name: 'Ver Menu',
              value: obj.permissions.config.menu,
            },
          ],
          Archivos: [
            {
              name: 'Downloads',
              value: obj.permissions.files.download,
            },
            {
              name: 'Uploads',
              value: obj.permissions.files.upload,
            },
          ],
          Paneles: [
            {
              name: 'Ver Menu',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.view_menu
                  : false,
            },
            {
              name: 'Compartir Paneles',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.share_panel
                  : false,
            },
            {
              name: 'Crear Paneles',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.create_panel
                  : false,
            },
            {
              name: 'Editar Paneles',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.edit_panel
                  : false,
            },
            {
              name: 'Eliminar Paneles',
              value:
                obj.permissions.panels !== undefined
                  ? obj.permissions.panels.delete_panel
                  : false,
            },
          ],
        };
      }

      commit('SET_STATE_PROFILE', {
        permissions,
        nameProfile,
        profileId: obj._id,
      });
    },
    async setStateDefault({ commit }) {
      commit('SET_PERMISSIONS_DEFAULT');
    },
  },
  mutations: {
    updateField,
    SET_ALL_PERMISSIONS(state, payload) {
      state.allPermissions = payload;
    },
    GET_PROFILE(state, payload) {
      state.profileType = payload.type;
      state.profileId = payload._id;
    },
    SET_PROFILES(state, payload) {
      state.profiles = payload;
    },
    SET_PERMISSIONS_DEFAULT(state) {
      state.nameProfile = null;
      state.permissions = {
        Ações: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Detalhes',
            value: false,
          },
          {
            name: 'Editar Ação',
            value: false,
          },
          {
            name: 'Enviar (disparo)',
            value: false,
          },
          {
            name: 'Excluir Ação',
            value: false,
          },
          {
            name: 'Criar Ação',
            value: false,
          },
        ],
        Respostas: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Editar Comentário',
            value: false,
          },
          {
            name: 'Excluir Resposta',
            value: false,
          },
          {
            name: 'Modo categorização',
            value: false,
          },
        ],
        Manual: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Registrar Resposta',
            value: false,
          },
        ],
        Disparos: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Visualizar Reenvio',
            value: false,
          },
          {
            name: 'Reenviar Reenvio',
            value: false,
          },
          {
            name: 'Executar Reenvio',
            value: false,
          },
          {
            name: 'Visualizar Lembretes',
            value: false,
          },
          {
            name: 'Cancelar Lembretes',
            value: false,
          },
          {
            name: 'Visualizar Agendamentos',
            value: false,
          },
          {
            name: 'Cancelar Agendamentos',
            value: false,
          },
        ],
        Tratativas: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Detalhes',
            value: false,
          },
          {
            name: 'Categorizar Resposta',
            value: false,
          },
          {
            name: 'Alterar Status',
            value: false,
          },
          {
            name: 'Alterar Status Encerrado',
            value: false,
          },
          {
            name: 'Tratativa em Massa',
            value: false,
          },
          {
            name: 'Responder por email',
            value: false,
          },
          {
            name: 'Categorizar tratativa',
            value: false,
          },
          {
            name: 'Habilita comentário',
            value: false,
          },
        ],
        Relatórios: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Power BI',
            value: false,
          },
          // {
          //   name: 'Análise IA',
          //   value: false,
          // },
        ],
        Lixeira: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Restaurar Resposta',
            value: false,
          },
          {
            name: 'Restaurar Ação',
            value: false,
          },
        ],
        Dashboard: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
        ],
        Clientes: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Editar dados',
            value: false,
          },
        ],
        'Grupo de Ações': [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Associação de Ações',
            value: false,
          },
        ],
        Configurações: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
        ],
        Arquivos: [
          {
            name: 'Downloads',
            value: false,
          },
          {
            name: 'Uploads',
            value: false,
          },
        ],
        Painéis: [
          {
            name: 'Visualizar Menu',
            value: false,
          },
          {
            name: 'Compartilhar Painéis',
            value: false,
          },
          {
            name: 'Criar Painéis',
            value: false,
          },
          {
            name: 'Editar Painéis',
            value: false,
          },
          {
            name: 'Excluir Painéis',
            value: false,
          },
        ],
      };
    },
    SET_STATE_PROFILE(state, payload) {
      state.nameProfile = payload.nameProfile;
      state.permissions = payload.permissions;
      state.profileId = payload.profileId;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profiles/index.js